module.exports = __webpack_public_path__ + "img/Frame-6.97ec1996.png";